import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { getConfig } from '../../config';
import { postInteractionLog } from '../../interaction-metrics';
import { withProfiling } from '../../self-measurements';
import { getVCObserver } from '../../vc';
import getInteractionStatus from './get-interaction-status';
import getPageVisibilityUpToTTAI from './get-page-visibility-up-to-ttai';
import getSSRDoneTimeValue from './get-ssr-done-time-value';
var getVCMetrics = withProfiling( /*#__PURE__*/function () {
  var _getVCMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(interaction) {
    var _config$vc, _config$vc$ssrWhiteli, _interaction$apdex, _config$experimentalI;
    var config, interactionStatus, pageVisibilityUpToTTAI, isSSREnabled, ssr, tti, prefix, result, _result$ufoVcRev, ttvcV2Revision, VC;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = getConfig();
          if (config !== null && config !== void 0 && (_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", {});
        case 3:
          if (!(interaction.type !== 'page_load' && interaction.type !== 'transition')) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", {});
        case 5:
          interactionStatus = getInteractionStatus(interaction);
          pageVisibilityUpToTTAI = getPageVisibilityUpToTTAI(interaction);
          if (!((interactionStatus.originalInteractionStatus !== 'SUCCEEDED' || pageVisibilityUpToTTAI !== 'visible') && fg('platform_ufo_no_vc_on_aborted'))) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", {});
        case 9:
          isSSREnabled = (config === null || config === void 0 ? void 0 : config.ssr) || (config === null || config === void 0 || (_config$vc$ssrWhiteli = config.vc.ssrWhitelist) === null || _config$vc$ssrWhiteli === void 0 ? void 0 : _config$vc$ssrWhiteli.includes(interaction.ufoName));
          ssr = interaction.type === 'page_load' && isSSREnabled ? {
            ssr: getSSRDoneTimeValue(config)
          } : null;
          postInteractionLog.setVCObserverSSRConfig(ssr);
          tti = (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime;
          prefix = 'ufo';
          _context.next = 16;
          return getVCObserver().getVCResult(_objectSpread({
            start: interaction.start,
            stop: interaction.end,
            tti: tti,
            prefix: prefix,
            vc: interaction.vc,
            isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED'
          }, ssr));
        case 16:
          result = _context.sent;
          if ((_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) {
            getVCObserver().stop();
          }
          postInteractionLog.setLastInteractionFinishVCResult(result);
          if (!fg('platform_ufo_disable_ttvc_v1')) {
            _context.next = 26;
            break;
          }
          ttvcV2Revision = result === null || result === void 0 || (_result$ufoVcRev = result['ufo:vc:rev']) === null || _result$ufoVcRev === void 0 ? void 0 : _result$ufoVcRev.find(function (_ref) {
            var revision = _ref.revision;
            return revision === 'fy25.02';
          });
          if (ttvcV2Revision !== null && ttvcV2Revision !== void 0 && ttvcV2Revision.clean) {
            _context.next = 23;
            break;
          }
          return _context.abrupt("return", result);
        case 23:
          return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
            'metric:vc90': ttvcV2Revision['metric:vc90']
          }));
        case 26:
          VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
          if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
            _context.next = 29;
            break;
          }
          return _context.abrupt("return", result);
        case 29:
          if (!(interactionStatus.originalInteractionStatus !== 'SUCCEEDED' || pageVisibilityUpToTTAI !== 'visible')) {
            _context.next = 31;
            break;
          }
          return _context.abrupt("return", result);
        case 31:
          return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
            'metric:vc90': VC['90']
          }));
        case 32:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  function getVCMetrics(_x) {
    return _getVCMetrics.apply(this, arguments);
  }
  return getVCMetrics;
}());
export default getVCMetrics;